const e = {
  name: "Testing",
  dimensions: { width: 30, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 40" style="enable-background:new 0 0 30 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22,0H8v6h2v4.9C4.2,12.9,0,18.5,0,25c0,8.3,6.7,15,15,15c8.3,0,15-6.7,15-15c0-6.5-4.2-12.1-10-14.1V6h2V0z
			 M12,4h-2V2h10v2h-2v8.3l0.7,0.2c5.2,1.6,9.1,6.3,9.3,12c-3.5,3.2-8.9,3.1-12.3-0.3c-2.1-2.1-4.9-3.2-7.7-3.2c-2,0-4,0.6-5.8,1.7
			c0.8-4.9,4.4-8.8,9.1-10.2l0.7-0.2V4z M2,25.4c1.7-1.6,3.8-2.3,6-2.3c2.3,0,4.5,0.9,6.3,2.6c3.7,3.7,9.3,4.2,13.5,1.5
			C26.8,33.3,21.4,38,15,38C8,38,2.2,32.4,2,25.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Testing
};
